import { CLASS_NAMES } from "../constants/scrollAnimationConstants";

export class ScrollAnimation {
  constructor(readonly root: HTMLElement) {}

  addClassName = (entries: IntersectionObserverEntry[]): void => {
    entries.forEach(async (entry: IntersectionObserverEntry) => {
      const ratio: number = Math.ceil(entry.intersectionRatio * 100);
      const target: Element = entry.target;
      const classList: DOMTokenList = target.classList;

      if (ratio >= 20) {
        const imgElements: HTMLCollectionOf<HTMLImageElement> = target.getElementsByTagName("img");
        if (target instanceof HTMLElement) {
          await this.listenImgs(imgElements).finally(() => {
            const animateDelay: number = Number(target.dataset.animateDelay) || 0;
            setTimeout(() => {
              // 表示開始 className 追加
              !classList.contains(CLASS_NAMES.ANIMATE) && target.classList.add(CLASS_NAMES.ANIMATE);
            }, animateDelay);
          });
        }
        this.observer.unobserve(target);
      }
    });
  };

  observer = new IntersectionObserver(this.addClassName, {
    root: this.root,
    threshold: [0, 0.2, 0.4, 0.6, 0.8, 1],
  });

  observe = () => {
    const dataTargetQueries: HTMLCollectionOf<Element> = this.root.getElementsByClassName(CLASS_NAMES.ITEM);
    if (dataTargetQueries.length < 1) return;
    for (let i = 0; i < dataTargetQueries.length; i++) {
      const target: Element = dataTargetQueries[i];
      if (target) this.observer.observe(target);
    }
  };

  async listenImgs(imgs: HTMLCollectionOf<HTMLImageElement>) {
    return new Promise(function (resolve, reject) {
      const length = imgs.length;
      if (length < 1) {
        return reject();
      } else {
        let loadedImg: number = 0;
        for (let i = 0; i < length; i++) {
          const img: HTMLImageElement = imgs[i];
          img.complete && (loadedImg += 1);
        }
        if (loadedImg === length) {
          return resolve(loadedImg);
        } else {
          return reject();
        }
      }
    });
  }
}
